export const institutionsP1Messages = [
  {
    "label": "with P1",
    "count": 3178
  },
  {
    "label": "without P1",
    "count": 2179
  }
]